import { END_POINTS } from "../constants/url";
import { CommonBody, PurchasedSubscription, Subscription } from "../types/General";

import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  data: {
    totalPages: number;
    count: number;
  };
  statusCode: number;
  message: string;
};

type GetUserParams = {
  page: number;
  query: string;
};

type GetPurchasedParams = {
  page: number;
  query: string;
  status?: string;
};

type PutBlockParams = {
  subsId: string;
  encryptedBody: CommonBody;
};

type UpdateParams = {
  subsId: string | undefined;
  encryptedBody: CommonBody;
};

export const subscriptionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSubscriptions: builder.query<
      CommonResponseType & {
        data: {
          count: number;
          totalCount: number;
          membership: Subscription[];
        };
      },
      GetUserParams
    >({
      query: ({ page, query }) => ({
        url: END_POINTS.membership + "?page=" + page + "&search=" + query,
        method: "GET",
      }),
    }),

    getPurchasedSubscriptions: builder.query<
      CommonResponseType & {
        data: {
          count: number;
          pages: number;
          subscribedPlans?: PurchasedSubscription[];
          susbcribedPlans?: PurchasedSubscription[];
        };
      },
      GetPurchasedParams
    >({
      query: ({ page, query, status }) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        if (query) params.set("search", query);
        if (status !== undefined && status !== "") params.set("status", status);
        return {
          url: `${END_POINTS.subscriptions}?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    addSubscription: builder.mutation<
      { message: string; statusCode: number; data: Subscription },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.membership,
        method: "POST",
        body,
      }),
    }),

    getSubscriptionById: builder.query<
      CommonResponseType & { data: Subscription },
      { subId: string | undefined }
    >({
      query: ({ subId }) => ({
        url: `${END_POINTS.membership}/${subId}`,
        method: "GET",
      }),
    }),

    changeSubscriptionStatus: builder.mutation<
      { message: string; statusCode: number },
      PutBlockParams
    >({
      query: ({ encryptedBody, subsId }) => ({
        url: `${END_POINTS.membership}/${subsId}`,
        method: "PUT",
        body: encryptedBody,
      }),
    }),

    deleteSubscription: builder.mutation<
      CommonResponseType,
      { subsId: string }
    >({
      query: ({ subsId }) => ({
        url: `${END_POINTS.membership}/${subsId}`,
        method: "DELETE",
      }),
    }),

    updateSubscription: builder.mutation<
      CommonResponseType & { data: Subscription[] },
      UpdateParams
    >({
      query: ({ encryptedBody, subsId }) => ({
        url: `${END_POINTS.membership}/${subsId}`,
        method: "PUT",
        body: encryptedBody,
      }),
    }),
  }),
});

export const {
  useLazyGetAllSubscriptionsQuery,
  useLazyGetPurchasedSubscriptionsQuery,
  useAddSubscriptionMutation,
  useLazyGetSubscriptionByIdQuery,
  useChangeSubscriptionStatusMutation,
  useDeleteSubscriptionMutation,
  useUpdateSubscriptionMutation,
} = subscriptionApi;
